var trackingConst = require('src/interlock/no-ui/tracking/constant');
var responsiveToolkit = require('src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit');
var docCookies = require('doc-cookies');
var timestamp = window.EDM.PageValues.page.timestamp;
var NMConst = require('./constants');
var IMG_HOST = NMConst.IMG_HOST;
var GLOBAL_NAV_SPONSORSHIP_CONST;
var QUICK_LINKS_SPONSORSHIP_CONST;

function hasSponsorshipData() {
    QUICK_LINKS_SPONSORSHIP_CONST = window.EDMDataStorage['quickLinksSponsorshipData'] ?
        window.EDMDataStorage['quickLinksSponsorshipData'].MAKE : {};

    if (window.EDMDataStorage['globalNavSponsorshipData']) {
        GLOBAL_NAV_SPONSORSHIP_CONST = window.EDMDataStorage['globalNavSponsorshipData'].MATRIX;
        return true;
    } else {
        return false;
    }
}

function fireImpressionTracking(vehicle, isMobile, data){
    if(isMobile) {
        var sponsorshipWrapperMobile = data.sponsorshipWrapper ? data.sponsorshipWrapper : '.sponsorship-item-small';

        checkImpressionTracker($(sponsorshipWrapperMobile));
        initMobileImpressionTracker(vehicle, sponsorshipWrapperMobile);
    } else {
        if (!$.isEmptyObject(data)){
            var sponsorshipWrapperWired = $(data.tabId + ' .sponsorship-item');

            checkImpressionTracker(sponsorshipWrapperWired);
            initWiredTabImpressionTracker(vehicle, data.tabId);
        }
    }
}

function checkImpressionTracker(sponsorshipWrapper) {
    var impressionTrackers = sponsorshipWrapper.children('img');

    if(impressionTrackers.length !== 0) {
        impressionTrackers.detach();
    }
}

function refreshTimestamp() {
    return Date.now()+'';
}

function initWiredTabImpressionTracker(vehicle, tab_id) {
    if(docCookies.getItem('disableallthirdparty') || docCookies.getItem('disableallads')) { return; }
    var timestamp = refreshTimestamp();
    $('<img>', {src: vehicle.img.wired.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
        .appendTo(tab_id + ' .sponsorship-item');
    $('<img>', {src: vehicle.img.wired.impressionTracker2, width: 1, height: 1})
        .appendTo(tab_id + ' .sponsorship-item');
}

function initMobileImpressionTracker(vehicle, sponsorshipWrapper) {
    if(docCookies.getItem('disableallthirdparty') || docCookies.getItem('disableallads')) { return; }
    var timestamp = refreshTimestamp();
    $('<img>', {src: vehicle.img.mobile.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
        .appendTo(sponsorshipWrapper);
    $('<img>', {src: vehicle.img.mobile.impressionTracker2, width: 1, height: 1})
        .appendTo(sponsorshipWrapper);
}

function appendImageToHeader(vehicle) {
    var imgWiredContainer = $('<a>',
            {href: vehicle.img.wired.clickTracker.replace('[timestamp]', timestamp)}).appendTo('.sponsorship-item'),
        imgMobileContainer = $('<a>',
            {href: vehicle.img.mobile.clickTracker.replace('[timestamp]', timestamp)}).appendTo('.sponsorship-item-small');

    $('<img>', {src: IMG_HOST + vehicle.img.wired.imgURL, class: 'ad-img'}).appendTo(imgWiredContainer);
    $('<img>', {src: IMG_HOST + vehicle.img.mobile.imgURL, width: 277, height: 55})
        .appendTo(imgMobileContainer);
}

function getRandomVehicle(responseType) {
    var segmentedType = GLOBAL_NAV_SPONSORSHIP_CONST[responseType] ? responseType : 'default';
    var segmentedVehicles = GLOBAL_NAV_SPONSORSHIP_CONST[segmentedType];

    return segmentedVehicles[Math.floor(Math.random()*segmentedVehicles.length)];
}

function setSponsorshipExampleModelHP(vehicle) {
    var container, elem;
    var link;
    if (responsiveToolkit.is('<=sm')) {
        container = $('.xsmall.sponsorship-model-example-hp');
        link = vehicle['link']['mobile'];
    }
    else {
        container = $('.sponsorship-model-example-hp:not(.xsmall)');
        link = vehicle['link']['wired'];
    }
    elem = container.find('a');

    if(!docCookies.getItem('disableallthirdparty') && !docCookies.getItem('disableallads')) {
        $('<img>', {src: link.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
            .appendTo(container);
        $('<img>', {src: link.impressionTracker2, width: 1, height: 1})
            .appendTo(container);
    }

    elem.attr('href', link.modelURL.replace('[timestamp]', timestamp)).text(vehicle.name);
    elem.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, vehicle.nicename);
    container.show();
}

function setSponsorshipExampleMakeHP() {
    if (responsiveToolkit.is('<=sm')) {
        return;
    }
    var container = $('.sponsorship-make-example-hp'),
        elem = container.find('a');

    if(!docCookies.getItem('disableallthirdparty') && !docCookies.getItem('disableallads')) {
        $('<img>', {src: QUICK_LINKS_SPONSORSHIP_CONST.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
            .appendTo(container);
        $('<img>', {src: QUICK_LINKS_SPONSORSHIP_CONST.impressionTracker2, width: 1, height: 1})
            .appendTo(container);
    }

    elem.attr('href', QUICK_LINKS_SPONSORSHIP_CONST.modelURL.replace('[timestamp]', timestamp)).text(QUICK_LINKS_SPONSORSHIP_CONST.name);
    elem.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, QUICK_LINKS_SPONSORSHIP_CONST.nicename);
    container.show();
}

module.exports = {
    fireImpressionTracking: fireImpressionTracking,
    initWiredTabImpressionTracker: initWiredTabImpressionTracker,
    initMobileImpressionTracker: initMobileImpressionTracker,
    appendImageToHeader: appendImageToHeader,
    getRandomVehicle: getRandomVehicle,
    setSponsorshipExampleModelHP: setSponsorshipExampleModelHP,
    setSponsorshipExampleMakeHP: setSponsorshipExampleMakeHP,
    hasSponsorshipData: hasSponsorshipData
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav-sponsorship/nav-sponsorship.js
// module id = 66
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14